import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { actionCreators, store } from "@App/state";
import { bindActionCreators } from "@reduxjs/toolkit";

/**
 * A custom hook that checks if all needed data was loaded from the api on component mount
 * and returns a method to parse the data to the url query parameters.
 */
export const useHSNTSNParameters = () => {
  const [searchParams] = useSearchParams();

  const dispatch = useDispatch();
  const { setHSNTSN } = bindActionCreators(actionCreators, dispatch);

  const hsntsnQuery = searchParams.get("hsntsn");

  useEffect(() => {
    if (hsntsnQuery) {
      setHSNTSN(hsntsnQuery);
    }
  }, [hsntsnQuery]);

  const hsntsnQueryParams = (): Record<string, string> => {
    return {
      ...(store.getState().orders.hsntsn && {
        hsntsn: store.getState().orders.hsntsn,
      }),
    };
  };

  return { hsntsnQueryParams };
};
